import { useState, useEffect } from 'react';
import { Platform, Dimensions } from 'react-native';

/**
 * Hook to get window width and detect if we should use mobile layout
 * On web, listens to window resize events
 * On native, uses Dimensions API
 */
export const useWindowWidth = () => {
  const [width, setWidth] = useState(() => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      return window.innerWidth;
    }
    return Dimensions.get('window').width;
  });

  useEffect(() => {
    if (Platform.OS !== 'web') {
      const subscription = Dimensions.addEventListener('change', ({ window }) => {
        setWidth(window.width);
      });
      return () => subscription?.remove();
    }

    // Web: listen to window resize
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
};

/**
 * Hook to check if we should use mobile layout (width < 800px)
 */
export const useIsMobileLayout = () => {
  const width = useWindowWidth();
  return width < 800;
};



